import { type StackNavigationOptions } from '@react-navigation/stack'
import { useReducedMotion } from 'react-native-reanimated'

import { Header } from '@/components'

export const useStackScreenOptions = (): StackNavigationOptions => {
  const isReducedMotion = useReducedMotion()

  return {
    animation: isReducedMotion ? 'none' : 'default',
    animationTypeForReplace: 'pop',
    cardOverlayEnabled: false,
    cardShadowEnabled: false,
    cardStyle: {
      // DO NOT REMOVE!
      // this ensures that each card takes up all available vertical space, without which scrollviews are not properly
      // contained and allow their content to exceed screen boundaries
      flex: 1
    },
    detachPreviousScreen: true,
    gestureEnabled: false,
    header: Header
  }
}
